import React, { Component } from "react";
import "./EmailVerification.scss";
import { connect } from "react-redux";
import Dimmer from "semantic-ui-react/dist/es/modules/Dimmer";
import Loader from "semantic-ui-react/dist/es/elements/Loader";
import { emailVerify } from "../../../actions/authAction";
import { Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import { ReactComponent as AuthenticateIcon } from "../../../assets/svg/authentication-icon.svg";

class EmailVerification extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tokenNotAvail: false,
        };
    }

    componentDidUpdate() {
        document.title = "Radarr | Email Verification";
    }

    componentDidMount() {
        if (window.location.href.indexOf("?token=") > 0) {
            const _url = window.location;
            const accessToken = new URLSearchParams(_url.search).get("token");
            let param = {};
            param["token"] = accessToken;
            this.props.emailVerification(param);
        } else {
            toast.error("Email verification failed.Please try again");
            this.setState({ tokenNotAvail: !this.state.tokenNotAvail });
        }
    }
    render() {
        let tokenDeficiency = this.state.tokenNotAvail;
        return (
            <div className="emailVrification">
                <h3 className="header__text">We are veryfying your email Please wait for some time</h3>
                <div className="authenticate__icon">
                    <AuthenticateIcon />
                </div>
                {this.props.emailVerifyLoading && (
                    <div className="list-loading">
                        <Dimmer inverted active>
                            <Loader size="big skiptranslate">Authenticating</Loader>
                        </Dimmer>
                    </div>
                )}
                {this.props.emailVerified && <Redirect to="/home" />}
                {(this.props.emailVerificationFailed || tokenDeficiency) && <Redirect to="/signin" />}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        emailVerified: state.authReducer.emailVerified,
        emailVerifyLoading: state.authReducer.emailVerifyLoading,
        emailVerificationFailed: state.authReducer.emailVerificationFailed,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        emailVerification: (data) => dispatch(emailVerify(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailVerification);
